export default function BackArrowIco() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 5.0013H9M1 5.0013L4.33333 1.66797M1 5.0013L4.33333 8.33464"
        stroke="#7F56D9"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
